import { createLogic } from 'redux-logic'
import { map, timeout } from 'rxjs/operators'
import * as constants from '../constants'
import Comps from '@engine/comps'

function limitSourceNotes (templateName, compsData, limit) {
  return ['studentHousingComps', 'rentComps', 'rentCompsT2', 'rentCompsT3', 'rentCompsT4', 'rentCompsT5', 'rentCompsT6'].includes(templateName) ? compsData.map(propertyData => {
        const notesWithoutWhiteSpaces = propertyData.notes.trim()
        const notesWithLimit = notesWithoutWhiteSpaces.length >= limit ? notesWithoutWhiteSpaces.substring(0, limit) : notesWithoutWhiteSpaces

        return { ...propertyData, notes: notesWithLimit }
      }) : compsData
}

export const downloadPdf = createLogic({
  type: constants.DOWNLOAD_PDF_S3.ACTION,
  processOptions: {
    successType: constants.DOWNLOAD_PDF_S3.FULFILLED,
    failType: constants.DOWNLOAD_PDF_S3.REJECTED
  },
  process({ http, getState }) {
    const state = getState()
    let compsData = Comps.selectors.comps.compsData(state) || state.compsData
    const templateName = Comps.selectors.comps.templateName(state) || state.templateName
    const templateDataLimits = Comps.selectors.comps.templateDataLimits(state) || state.templateDataLimits
    compsData = limitSourceNotes(templateName, compsData, templateDataLimits.sourceNotesCount)

    let projectName = Comps.selectors.comps.projectName(state) || state.projectName
    if (projectName === undefined) {
      projectName = Comps.selectors.comps.projectNameCopy(state) || state.projectNameCopy
    }
    // eslint-disable-next-line
    window._mtm.push({ 'event': 'downloadPdf', 'templateType': templateName, 'projectName': projectName })
    const toggleSettings = Comps.selectors.comps.toggleSettings(state) || state.toggleSettings
    const barChartData = Comps.selectors.comps.barChartData(state)
    const fpBarChartData = Comps.selectors.comps.fpBarChartData(state)
    const fpSummaryData = Comps.selectors.comps.fpSummaryData(state)
    const fpSummaryTableColumnsAll = Comps.selectors.comps.fpSummaryTableColumns(state)
    const fpSummaryTableColumnsFiltered = {}
    for (const key in fpSummaryTableColumnsAll) {
      if (fpSummaryTableColumnsAll.hasOwnProperty(key)) {
        fpSummaryTableColumnsFiltered[key] = fpSummaryTableColumnsAll[key].filter(obj => obj.key !== 'NA')
      }
    }
    const fpSummaryTableColumns = {}
    for (const key in fpSummaryTableColumnsFiltered) {
      if (fpSummaryData && fpSummaryData.some(fpObj => fpObj.type === key)) {
        fpSummaryTableColumns[key] = fpSummaryTableColumnsFiltered[key]
      }
    }
    const isSubjectPropertyDeleted = Comps.selectors.comps.isSubjectPropertyDeleted(state)
    const barChartSettings = Comps.selectors.comps.barChartSettings(state)
    const themeColors = Comps.selectors.comps.themeColors(state)
    const propertyFieldsAll = Comps.selectors.comps.propertyFields(state)
    const propertyFieldsValid = propertyFieldsAll && propertyFieldsAll.filter(propertyField => propertyField.key !== 'NA')
    const propertyFields = isSubjectPropertyDeleted ? propertyFieldsValid.filter(col => col.key !== 'Distance') : propertyFieldsValid
    const subjectPropFieldsAll = Comps.selectors.comps.subjectPropertyFields(state)
    const subjectPropertyFieldsValid = subjectPropFieldsAll && subjectPropFieldsAll.filter(propertyField => propertyField.key !== 'NA')
    const subjectPropertyFields = isSubjectPropertyDeleted ? subjectPropertyFieldsValid.filter(col => col.key !== 'Distance') : subjectPropertyFieldsValid
    const donutChartThemeColors = Comps.selectors.comps.donutChartThemeColors(state)
    const summaryTableColumnsAll = Comps.selectors.comps.summaryTableColumns(state)
    const summaryTableColumnsValid = summaryTableColumnsAll && summaryTableColumnsAll.filter(col => col.key !== 'NA')
    const summaryTableColumns = isSubjectPropertyDeleted ? summaryTableColumnsValid.filter(col => col.key !== 'Distance') : summaryTableColumnsValid
    const summaryDisclaimerText = Comps.selectors.comps.summaryDisclaimerText(state)
    const unitMixTableColumnsAll = Comps.selectors.comps.unitMixTableColumns(state)
    const unitMixTableColumns = unitMixTableColumnsAll && unitMixTableColumnsAll.filter(obj => obj.key !== 'NA')
    const compsWithSubjectProperty = Comps.selectors.comps.compsWithSubjectProperty(state)

    const reqPayload = {
      compsData,
      templateDataLimits,
      templateName,
      toggleSettings,
      barChartData,
      fpBarChartData,
      fpSummaryData,
      fpSummaryTableColumns,
      barChartSettings,
      themeColors,
      donutChartThemeColors,
      propertyFields,
      subjectPropertyFields,
      projectName: `${projectName}.pdf`,
      summaryTableColumns,
      summaryDisclaimerText,
      unitMixTableColumns,
      compsWithSubjectProperty
    }

    return http
      .post('/comps/pdf', reqPayload)
      .pipe(
        timeout(60000), // 60 seconds timeout
        map(http.getBody)
      )
  }
})
